import { DATASET_INSIGHT_TYPES } from 'reporting-data/tsTypes/datasetInsightTypes';
export const ADVANCED_INSIGHT_TYPES = {
  FORECAST_TRENDLINE: DATASET_INSIGHT_TYPES.FORECAST_TRENDLINE,
  ANOMALY_DETECTION: DATASET_INSIGHT_TYPES.ANOMALY_DETECTION
};
export const MUTUALLY_INCLUSIVE_INSIGHT_TYPES = {
  ANOMALY_DETECTION: DATASET_INSIGHT_TYPES.ANOMALY_DETECTION
};
export const VALID_INSIGHTS_API_URL = 'reporting/v2/insights/valid-insights';
export const ADVANCED_INSIGHTS_UPGRADE_KEY = 'advanced-reporting-insights';